<template>
  <UiSnackbar
    :is-shown="showSnackbar"
    data-testid="snackbar"
    class="z-100"
    :type="type"
    :icon-name="icon"
    icon-size="lg"
    @action-click="actionCallback">
    <slot></slot>
    <template v-if="actionLabel" #action>
      {{ actionLabel }}
    </template>
  </UiSnackbar>
</template>

<script setup lang="ts">
import { type UiIconName } from "@dpa-id-components/dpa-shared-components/src/components/UiIcon/UiIcon.vue";
import UiSnackbar from "@dpa-id-components/dpa-shared-components/src/components/UiSnackbar/UiSnackbar.vue";
import { ref, watch } from "vue";

const props = withDefaults(
  defineProps<{
    icon?: UiIconName;
    showSnackbar?: boolean;
    hideAutomatically?: boolean;
    actionLabel?: string;
    actionCallback?: () => void;
    duration?: number;
    type?: "info" | "error" | "success";
  }>(),
  {
    showSnackbar: false,
    hideAutomatically: true,
    actionLabel: undefined,
    actionCallback: undefined,
    duration: 5000,
    type: "info",
    icon: undefined,
  },
);

// In this case we want the value to be de-coupled from the reactivity
const showSnackbarValue = ref(props.showSnackbar);
const emit = defineEmits<{
  "hide-snackbar": [];
}>();

watch(
  () => props.showSnackbar,
  (newValue) => {
    showSnackbarValue.value = newValue;
    if (newValue && props.hideAutomatically) {
      setTimeout(() => {
        showSnackbarValue.value = false;
        emit("hide-snackbar");
      }, props.duration);
    }
  },
);
</script>
